
export function renderNetraaLHReleaseNotes3 () {
    return (
  <div>
    <main className="transition-opacity duration-300">
      <div className="py-4">

        {/* Header */}
        <div id="release-details" className="mb-10 scroll-mt-24">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-bold tracking-wider text-orange-600 uppercase bg-orange-100 rounded-full dark:bg-orange-900/30 dark:text-orange-400">
            Release Notes
          </span>

          <h1 className="text-3xl lg:text-4xl font-extrabold text-text-main dark:text-white tracking-tight mb-4">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
              Netraa LH Release Notes
            </span>
          </h1>

          <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
            Latest updates including feature enhancements, performance improvements, and bug fixes.
          </p>
        </div>

        {/* Confidentiality Statement */}
        {/* <section id="confidentiality" className="mb-12 scroll-mt-24">
          <div className="bg-red-50 dark:bg-red-900/20 border-l-4 border-red-500 p-4 rounded-r-lg">
            <h4 className="text-sm font-bold text-red-800 dark:text-red-300 mb-2">
              Confidentiality Statement
            </h4>
            <p className="text-xs text-red-700 dark:text-red-400 leading-relaxed">
              The information contained in any Communication or Documentation distributed by ApMoSys, including attachments, is strictly confidential and intended solely for delivery to, and authorized use by, the identified addressee(s), as it may contain legally privileged and/or confidential information. If you are not the intended recipient of the Communication, you are hereby notified that any reading, disclosure, dissemination, distribution or copying of the Communication, and any attachments thereto, is strictly prohibited. If you have received the Communication in error, please notify the sender immediately and delete the message, and any copies and printouts thereof, from your records.
            </p>
          </div>
        </section> */}

        {/* Release Details */}
        <section id="" className="mb-12 scroll-mt-24">
          <h2 className="text-xl font-bold text-text-main dark:text-white mb-4">
            Release Details
          </h2>

          <div className="overflow-x-auto border border-border-color dark:border-border-dark rounded-xl">
            <table className="w-auto text-left border-collapse text-sm">
              <thead>
                <tr>
                  <th className="px-4 py-3 font-bold text-text-muted">Release Date</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Release Type</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Author Name</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-4 py-3 font-medium text-primary">27th Feb 2026</td>
                  <td className="px-4 py-3">Enhancements & Fixes</td>
                  <td className="px-4 py-3">Navodya Tyagi</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Introduction */}
        <section id="introduction" className="mb-12 scroll-mt-24">
          <div className="p-6 rounded-2xl bg-gradient-to-r from-orange-50 to-transparent dark:from-orange-900/20 border border-border-color dark:border-border-dark">
            
            <h2 className="text-2xl font-bold text-text-main dark:text-white mb-3">
              Introduction
            </h2>

            <p className="text-sm text-text-muted dark:text-gray-400 leading-relaxed">
              We are excited to announce the latest updates to our platform Netraa LH, packed with several feature enhancements, improvements, and bug fixes. This release aims to provide a better user experience, streamline processes, and increase overall efficiency.
            </p>

          </div>
        </section>

        {/* Enhancements */}
        <section id="enhancements" className="mb-16 scroll-mt-24">
          <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
            
            <span className="flex items-center justify-center w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 text-primary border border-orange-200 dark:border-orange-900/50">
              <span className="material-symbols-outlined text-[22px]">upgrade</span>
            </span>

            Enhancements
          </h2>

          <div className="space-y-6">

            {[
              {
                title: "Historical Data Table Enhancement",
                subtitle: "(Live Dashboard Page, What Went Wrong Page)",
                items: [
                  "Improved SLA evaluation logic to accurately calculate monitoring duration within the configured monitoring schedule window.",
                  "Implemented overlap-based timeframe calculation for SLA and returned the evaluated time window (overlap start–end) to frontend.",
                  "Improved table visibility by adding an error message column to display termination causes."
                ]
              },
              {
                title: "Visualization Improvements",
                items: [
                  "Maintained a consistent Historical Data table structure across both What Went Wrong and Live Dashboard pages."
                ]
              },
              {
                title: "Client Dropdown Improvements",
                items: [
                  "Added domain badges beside client names for better identification.",
                  "Selected clients now move to the top for improved visibility."
                ]
              }
            ].map((section, i) => (

              <div
                key={i}
                className="p-5 rounded-2xl border border-border-color dark:border-border-dark bg-surface-light dark:bg-surface-dark hover:shadow-md transition"
              >

                {/* Header */}
                <div className="flex items-start gap-4 mb-3">

                  {/* Number */}
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-600 font-bold text-sm flex-shrink-0">
                    {`1.${i + 1}`}
                  </div>

                  {/* Title */}
                  <div>
                    <h3 className="font-semibold text-text-main dark:text-white leading-snug">
                      {section.title}
                    </h3>
                    {section.subtitle && (
                      <p className="text-xs text-text-muted dark:text-gray-500">
                        {section.subtitle}
                      </p>
                    )}
                  </div>

                </div>

                {/* Content */}
                <ul className="space-y-2 text-sm text-text-muted dark:text-gray-400 pl-14">
                  {section.items.map((item, idx) => (
                    <li key={idx} className="relative pl-4">
                      <span className="absolute left-0 top-[6px] w-1.5 h-1.5 rounded-full bg-orange-500"></span>
                      {item}
                    </li>
                  ))}
                </ul>

              </div>

            ))}

          </div>
        </section>

      </div>
    </main>
  </div>
);
}